import Vue from 'vue';

export const EventBus = new Vue();

export const ENABLE_MAP_EVENT = 'enable_map_event'
